import {useQuery} from '@tanstack/react-query'
import logger from '@salesforce/retail-react-app/app/utils/logger-instance'
import {useCommerceApi, useAccessToken} from '@salesforce/commerce-sdk-react'

const useSiteCategory = ({parameters}) => {
    const api = useCommerceApi()
    const {getTokenWhenReady} = useAccessToken()

    const getCategory = async (parameters) => {
        try {
            const token = await getTokenWhenReady()
            const category = await api.shopperProducts.getCategory({
                parameters: parameters,
                headers: {
                    Authorization: `Bearer ${token}`
                },
                keepPreviousData: true
            })

            return category
        } catch (error) {
            logger.error('Error fetching Site Category', {
                namespace: 'useSiteCategory.getCategory',
                additionalProperties: {error}
            })
            throw error
        }
    }

    return useQuery({
        queryKey: ['use-site-category', parameters],
        queryFn: () => getCategory(parameters),
        keepPreviousData: true,
        staleTime: 15 * 60 * 1000,
        cacheTime: 15 * 60 * 1000,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false
    })
}

export default useSiteCategory
